// src/services/authService.js
import apiClient from './api'; // Axios instance

export default {
  login(credentials) {
    // credentials: { emailOrUsername: '...', password: '...' }
    return apiClient.post('/auth/login', credentials);
  },
  register(userData) {
    // userData: { username: '...', email: '...', password: '...', profile_title: '...' }
    return apiClient.post('/auth/register', userData);
  },
  // Google ile giriş için backend'deki /auth/google endpoint'ine yönlendirme
  // genellikle frontend'de basit bir link ile yapılır: <a href="http://localhost:5001/api/auth/google">
  // Backend bu adresten Google'a, sonra da frontend'deki callback'e yönlendirir.

  // Giriş yapmış kullanıcı bilgisini backend'den alma
  getMe() {
    return apiClient.get('/auth/me');
  }
};